import { call, put } from 'redux-saga/effects';
import { iActionGetAll } from '~/domain/interfaces/redux/chat/getAll';
import { GetAllChat } from '~/domain/usecases/chat/remote/GetAllChat';
import { makeRemoteGetAllChat } from '~/main/factories/usecases/chat/GetAllChatFactory';
import {
  getAllSuccess,
  getAllFailed,
} from '~/data/store/reducer/chat/actions/getAll';

export function* onGetAll(action: iActionGetAll) {
  const remoteGetAllChat = makeRemoteGetAllChat();

  try {
    const response: GetAllChat.Model = yield call(
      remoteGetAllChat.getAll,
      action.payload,
    );

    yield put(getAllSuccess(response));
  } catch (e) {
    yield put(getAllFailed());
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onGetAllSuccess() {}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onGetAllFailed() {}
